import { STATUS_COLORS } from './colors'

export const COLOR_STATUS_MAPPED = {
	[true]: STATUS_COLORS.green,
	[false]: STATUS_COLORS.red,
}
